
/**
 * 全局按钮操作权限指令
 * */
export const allow = {
  inserted: function (el, binding) {
    const permission = binding.value;
    if (permission) {
      if (!judge(permission)) {
        // 没有权限 移除Dom元素
        el.parentNode && el.parentNode.removeChild(el);
      }
    }
  }
};

// 判断是否有权限
function judge(value) {
  let isHas;
  if (Array.isArray(value[1])) {
    for (let i = 0; i < value[1].length; i++) {
      isHas = value[0].includes(value[1][i]);
      if (isHas) {
        break;
      }
    }
  } else {
    if (value[0]) {
      isHas = value[0].includes(value[1]);
    } else {
      isHas = false;
    }
  }
  // 开发添加所有权限
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'tests') {
    return true;
  }
  return isHas;
}


// 滚动加载更多
export const loadMore = {
  inserted(el, binding) {
    const callback = binding.value; // 获取指令绑定的回调函数  
    const options = binding.arg || {}; // 获取指令的参数（可选）  

    let isLoading = false; // 加载状态，防止重复加载  
    el.addEventListener('scroll', () => {
      // 判断是否滚动到底部  
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - (options.offset || 10)) {
        if (!isLoading) {
          isLoading = true; // 设置加载状态  
          callback(() => {
            isLoading = false; // 加载完成后重置状态  
          });
        }
      }
    });
  },
}


// el-table 表格自适应高度滚动--作用于父级元素
function setTableHeight(el, binding) {
  const { value } = binding;
  const customHeight = (value && value.height) || 40;
  const height = window.innerHeight - el.getBoundingClientRect().top - customHeight;
  console.log(height);

  el.style.height = `${height}px`;
}

export const tableHeight = {
  bind(el, binding) {
    el.resizeListener = () => {
      setTableHeight(el, binding);
    };
    window.document.body.addEventListener('resize', el.resizeListener);
  },
  update(el, binding) {
    setTableHeight(el, binding);
  },
  unbind(el) {
    window.document.body.removeEventListener('resize', el.resizeListener);
  }
};